<template>
  <div class="gmap-container" v-html="gmapiframe">
  </div>
</template>

<script>

export default {
	name: 'GmapView',
	props: {
		gmapiframe: {
			type: String,
		},
	},
};
</script>

